import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.number.constructor";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import userListMixin from '@/components/core/tenant/userListMixin';
import { copyToClipboard } from '@/utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'CoreTenantApiKeyList',
  mixins: [userListMixin],
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    tenantDetails: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    },
    isApiKeysVisible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    return {
      apiKeyEditDialog: false,
      isCreatingApiKey: false,
      editFormValidity: false,
      loadAccessOverlay: false,
      apiKeyModel: {},
      originalModel: {},
      apiKeyList: this.userList,
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }]
    };
  },
  computed: {
    fetchOptions: function fetchOptions() {
      return ['apikeys', 'no-rules'];
    },
    tableLocalized: function tableLocalized() {
      return {
        headers: [{
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.token'),
          value: 'email' // cannot sort by ID, but the email is set to the ID for api-keys

        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.title'),
          value: 'username'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.limit'),
          value: 'properties.apiLimit'
        }, {
          sortable: true,
          text: this.$i18n_t('accMgmt.user.apiKey.validUntil'),
          value: 'properties.apiValidityDate'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.active'),
          value: 'active'
        }, {
          sortable: false,
          text: this.$i18n_t('Common.actions'),
          value: '',
          align: 'right'
        }]
      };
    }
  },
  created: function () {
    var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.fetchUsers();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    copyToClipboard: copyToClipboard,
    toggleHideApiKeys: function toggleHideApiKeys() {
      this.isHideApiKeys = !this.isHideApiKeys;
    },
    addApiKey: function addApiKey() {
      var oneYearInFuture = new Date(new Date() - -86400 * 365 * 1000);
      this.apiKeyModel = {
        active: true,
        access: [],
        properties: {
          apiLimit: 50,
          apiValidityDate: oneYearInFuture
        }
      };
      this.apiKeyEditDialog = true;
    },
    editApiKey: function editApiKey(apiKey) {
      var _this2 = this;

      this.apiKeyModel = cloneDeep(apiKey);
      this.originalModel = cloneDeep(apiKey);
      this.apiKeyEditDialog = true;
      this.loadAccessOverlay = true;
      ApiService.getUser(this, apiKey.id).then(function (res) {
        _this2.apiKeyModel.access = cloneDeep(res.access);
        _this2.originalModel.access = cloneDeep(res.access);
      }).catch(function (error) {
        console.error(error);
      }).finally(function () {
        _this2.loadAccessOverlay = false;
      });
    },
    didSelectScope: function didSelectScope(scope) {
      this.apiKeyModel.scope = scope;
      this.apiKeyModel = cloneDeep(this.apiKeyModel);
      this.fetchDefaultRoles(scope.id);
    },
    fetchDefaultRoles: function fetchDefaultRoles(scopeId) {
      var _this3 = this;

      ApiService.fetchDefaultRoles(scopeId).then(function (roles) {
        if (roles.length > 0) {
          _this3.apiKeyModel.access = [{
            tenantId: roles[0].tenantId,
            scopeId: scopeId,
            Scope: {
              id: scopeId
            },
            roles: roles,
            primary: true
          }];
        }
      }).catch(function () {
        _this3.$snack(_this3.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    dateTimeChange: function dateTimeChange(dateObject) {
      this.apiKeyModel.properties.apiValidityDate = dateObject.from * 1000;
    },
    updatedUserAccess: function updatedUserAccess(access) {
      this.apiKeyModel.access = access;

      if ((access || []).length === 0) {
        delete this.apiKeyModel.scope;
      }
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;

      if (this.apiKeyModel.properties.apiValidityDate) {
        this.apiKeyModel.properties.apiValidityDate = new Date(this.apiKeyModel.properties.apiValidityDate).toISOString();
      }

      this.isCreatingApiKey = true;
      var promise = null;

      if (this.apiKeyModel.id) {
        promise = this.updateApiKey(this.apiKeyModel);
      } else {
        promise = this.createApiKey(this.apiKeyModel);
      }

      promise.catch(function (error) {
        console.error(error);
      }).finally(function () {
        // reset request-option to make sure the table(page) is reloaded
        _this4.priorRequestOptions = null;
        _this4.isCreatingApiKey = false;

        _this4.fetchUsers();
      });
    },
    createApiKey: function createApiKey(apiKey) {
      var _this5 = this;

      return ApiService.createApiUser(this.sessionPrimaryTenantIds[0], apiKey).then(function () {
        _this5.apiKeyEditDialog = false;

        _this5.$snack(_this5.$i18n_t('accMgmt.user.apiKey.createSuccessSnack'), 'success');
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('accMgmt.user.apiKey.createFailedSnack'), 'error');
        }
      });
    },
    updateApiKey: function updateApiKey(apiKey) {
      var _this6 = this;

      return ApiService.updateUser(apiKey).then(function () {
        return ApiService.updateUserAccess(apiKey, _this6.originalModel);
      }).then(function () {
        _this6.apiKeyEditDialog = false;

        _this6.$snack(_this6.$i18n_t('accMgmt.user.apiKey.editSuccessSnack'), 'success');
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('accMgmt.user.apiKey.editFailedSnack'), 'error');
        }

        console.error('Error updating user access', error);
      });
    },
    close: function close() {
      this.apiKeyEditDialog = false;
    }
  }
};